/* =========================================================
   GLAM GRACE – Menue, Kollektionsseite und Newsletter
   Grosses Menue mit Bildern (oeffnet beim Darueberfahren),
   Herz auf Produktkarten, Ansicht umschalten, Newsletter-Texte
   ========================================================= */
(function () {
  'use strict';

  var EN = /^en/i.test(document.documentElement.lang || '');
  function T(de, en) { return EN ? en : de; }

  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var hoverMQ = window.matchMedia('(hover: hover) and (min-width: 990px)');

  function el(tag, cls, text) {
    var node = document.createElement(tag);
    if (cls) node.className = cls;
    if (text != null) node.textContent = text;
    return node;
  }

  function readJSON(key, fallback) {
    try {
      var value = JSON.parse(window.localStorage.getItem(key));
      return value == null ? fallback : value;
    } catch (e) {
      return fallback;
    }
  }

  function writeJSON(key, value) {
    try {
      window.localStorage.setItem(key, JSON.stringify(value));
    } catch (e) {}
  }

  /* ---------- Grosses Menue ---------- */
  function setOpen(details, open) {
    var summary = details.querySelector('summary');
    if (open) details.setAttribute('open', '');
    else details.removeAttribute('open');
    if (summary) summary.setAttribute('aria-expanded', open ? 'true' : 'false');
  }

  function initMegaMenu() {
    var menus = Array.prototype.slice.call(document.querySelectorAll('.header__inline-menu details.mega-menu'));
    var source = document.querySelector('.gg-mega-source');

    menus.forEach(function (details) {
      if (details.dataset.ggMega) return;
      details.dataset.ggMega = '1';
      var content = details.querySelector('.mega-menu__content');
      var summary = details.querySelector('summary');

      if (content && summary && source) {
        var key = summary.textContent.trim().toLowerCase();
        var promos = Array.prototype.filter.call(source.querySelectorAll('.gg-promo'), function (promo) {
          return (promo.getAttribute('data-gg-menu') || '') === key;
        });
        if (promos.length) {
          var wrap = el('div', 'gg-mega__promos');
          promos.slice(0, 2).forEach(function (promo) { wrap.appendChild(promo); });
          content.appendChild(wrap);
          content.classList.add('gg-mega--has-promos');
        }
      }

      var item = details.closest('li') || details;
      var timer = null;
      item.addEventListener('mouseenter', function () {
        if (!hoverMQ.matches) return;
        clearTimeout(timer);
        menus.forEach(function (other) {
          if (other !== details && other.hasAttribute('open')) setOpen(other, false);
        });
        if (!details.hasAttribute('open')) setOpen(details, true);
      });
      item.addEventListener('mouseleave', function () {
        if (!hoverMQ.matches) return;
        clearTimeout(timer);
        timer = setTimeout(function () { setOpen(details, false); }, 180);
      });
      if (summary) {
        summary.addEventListener('click', function (event) {
          if (hoverMQ.matches && details.hasAttribute('open')) event.preventDefault();
        });
      }
    });
  }

  /* ---------- Herz auf Produktkarten ---------- */
  function addCardHearts() {
    var favs = readJSON('gg-favorites', []);
    if (!Array.isArray(favs)) favs = [];
    document.querySelectorAll('.card-wrapper').forEach(function (card) {
      if (card.querySelector('.gg-card-fav')) return;
      var link = card.querySelector('a[href*="/products/"]');
      if (!link) return;
      var match = link.getAttribute('href').match(/\/products\/([^/?#]+)/);
      if (!match) return;
      var handle = decodeURIComponent(match[1]);
      var host = card.querySelector('.card__inner') || card;
      var on = favs.indexOf(handle) !== -1;
      var btn = el('button', 'gg-fav-toggle gg-card-fav' + (on ? ' is-active' : ''));
      btn.type = 'button';
      btn.setAttribute('data-gg-fav', handle);
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      btn.setAttribute('aria-label', on ? T('Aus Favoriten entfernen', 'Remove from favorites') : T('Zu Favoriten hinzufügen', 'Add to favorites'));
      host.appendChild(btn);
    });
  }

  /* ---------- Ansicht umschalten (Spalten) ---------- */
  var VIEW_KEY = 'gg-grid-view';

  function gridIcon(cols) {
    var gap = 2;
    var cell = (16 - gap * (cols - 1)) / cols;
    var rows = cols === 1 ? 1 : 2;
    var height = rows * cell + (rows - 1) * gap;
    var rects = '';
    for (var r = 0; r < rows; r++) {
      for (var c = 0; c < cols; c++) {
        rects += '<rect x="' + c * (cell + gap) + '" y="' + r * (cell + gap) + '" width="' + cell + '" height="' + cell + '"/>';
      }
    }
    return '<svg viewBox="0 0 16 ' + height + '" aria-hidden="true" focusable="false">' + rects + '</svg>';
  }

  function applyView() {
    var grid = document.getElementById('product-grid');
    var view = readJSON(VIEW_KEY, { d: 4, m: 2 });
    if (grid) {
      grid.classList.remove('gg-d2', 'gg-d3', 'gg-d4', 'gg-m1', 'gg-m2');
      grid.classList.add('gg-d' + view.d, 'gg-m' + view.m);
    }
    document.querySelectorAll('.gg-gridtoggle__btn').forEach(function (btn) {
      var type = btn.getAttribute('data-type');
      var cols = Number(btn.getAttribute('data-cols'));
      btn.setAttribute('aria-pressed', view[type] === cols ? 'true' : 'false');
    });
  }

  function buildToggle(type, options) {
    var bar = el('div', 'gg-gridtoggle');
    bar.setAttribute('role', 'group');
    bar.setAttribute('aria-label', T('Ansicht', 'View'));
    options.forEach(function (cols) {
      var btn = el('button', 'gg-gridtoggle__btn gg-gridtoggle__btn--' + type);
      btn.type = 'button';
      btn.setAttribute('data-type', type);
      btn.setAttribute('data-cols', cols);
      btn.setAttribute('aria-label', cols + (cols === 1 ? T(' Spalte', ' column') : T(' Spalten', ' columns')));
      btn.innerHTML = gridIcon(cols);
      btn.addEventListener('click', function () {
        var view = readJSON(VIEW_KEY, { d: 4, m: 2 });
        view[type] = cols;
        writeJSON(VIEW_KEY, view);
        applyView();
      });
      bar.appendChild(btn);
    });
    return bar;
  }

  function initViewToggle() {
    if (!document.getElementById('product-grid')) return;
    var form = document.getElementById('FacetFiltersForm');
    if (form && !form.querySelector('.gg-gridtoggle')) form.appendChild(buildToggle('d', [2, 3, 4]));
    var container = document.querySelector('.facets-container');
    if (container && !container.querySelector(':scope > .gg-gridtoggle')) container.appendChild(buildToggle('m', [1, 2]));
    applyView();
  }

  /* ---------- Newsletter im Footer ---------- */
  function initNewsletter() {
    var block = document.querySelector('.footer-block__newsletter');
    if (!block || block.dataset.ggNews) return;
    block.dataset.ggNews = '1';
    var heading = block.querySelector('.footer-block__heading');
    if (heading) heading.insertAdjacentElement('afterend', el('p', 'gg-news__text', T('Melde dich an und erhalte vor allen anderen Zugang zu neuen Drops.', 'Sign up and get access to new drops before everyone else.')));
    var input = block.querySelector('.field__input');
    if (input) input.setAttribute('placeholder', T('Deine E-Mail-Adresse', 'Your email address'));
    var button = block.querySelector('.newsletter-form__button');
    if (button) {
      button.appendChild(el('span', 'gg-news__btn', T('Anmelden', 'Sign up')));
      var legal = el('p', 'gg-news__legal');
      legal.appendChild(document.createTextNode(T('Mit deiner Anmeldung akzeptierst du unsere ', 'By signing up you accept our ')));
      var link = el('a', '', T('Datenschutzerklärung', 'privacy policy'));
      link.href = ROOT + 'policies/privacy-policy';
      legal.appendChild(link);
      legal.appendChild(document.createTextNode('.'));
      button.insertAdjacentElement('beforebegin', legal);
    }
  }

  /* ---------- Suche im Header ---------- */
  function initSearch() {
    document.querySelectorAll('.header__search .search__input').forEach(function (input) {
      input.setAttribute('placeholder', T('Wonach suchst du?', 'What are you looking for?'));
    });
  }

  /* ---------- Startseite: Fortschrittslinie unter der Wisch-Reihe ---------- */
  function initSwipeRows() {
    document.querySelectorAll('[id$="__featured_collection"] .slider').forEach(function (slider) {
      if (slider.dataset.ggProgress) return;
      var buttons = slider.parentNode.querySelector('.slider-buttons');
      if (!buttons) return;
      slider.dataset.ggProgress = '1';
      var track = el('div', 'gg-progress');
      var bar = el('span', 'gg-progress__bar');
      track.setAttribute('aria-hidden', 'true');
      track.appendChild(bar);
      buttons.insertBefore(track, buttons.firstChild);
      function update() {
        var total = slider.scrollWidth;
        var view = slider.clientWidth;
        track.hidden = total <= view + 1;
        if (track.hidden) return;
        bar.style.width = (view / total) * 100 + '%';
        bar.style.left = (slider.scrollLeft / total) * 100 + '%';
      }
      slider.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();
    });
  }

  /* ---------- Preisfilter: Schieberegler fuer Von/Bis ---------- */
  function parsePrice(value) {
    var str = String(value || '').replace(/[^\d.,]/g, '');
    if (!str) return NaN;
    if (str.indexOf(',') !== -1) str = str.replace(/\./g, '').replace(',', '.');
    return parseFloat(str);
  }

  function initPriceSliders() {
    document.querySelectorAll('price-range').forEach(function (range) {
      if (range.querySelector('.gg-range')) return;
      var fields = range.querySelectorAll('input.field__input');
      if (fields.length < 2) return;
      var minField = fields[0];
      var maxField = fields[1];
      var max = Math.ceil(parsePrice(maxField.getAttribute('data-max')));
      if (!max || isNaN(max)) return;
      var currency = (range.querySelector('.field-currency') || {}).textContent || '€';
      currency = currency.trim();

      var wrap = el('div', 'gg-range');
      var track = el('div', 'gg-range__track');
      track.appendChild(el('span', 'gg-range__fill'));
      wrap.appendChild(track);

      function makeSlider(cls, label, value) {
        var input = document.createElement('input');
        input.type = 'range';
        input.className = 'gg-range__input ' + cls;
        input.min = '0';
        input.max = String(max);
        input.step = '1';
        input.value = String(value);
        input.setAttribute('aria-label', label);
        return input;
      }

      var low = parsePrice(minField.value);
      var high = parsePrice(maxField.value);
      var lowSlider = makeSlider('gg-range__input--min', T('Mindestpreis', 'Minimum price'), isNaN(low) ? 0 : Math.max(0, Math.floor(low)));
      var highSlider = makeSlider('gg-range__input--max', T('Höchstpreis', 'Maximum price'), isNaN(high) ? max : Math.min(max, Math.ceil(high)));
      wrap.appendChild(lowSlider);
      wrap.appendChild(highSlider);
      var label = el('p', 'gg-range__label');
      wrap.appendChild(label);

      function paint() {
        var a = Number(lowSlider.value);
        var b = Number(highSlider.value);
        wrap.style.setProperty('--a', (a / max) * 100 + '%');
        wrap.style.setProperty('--b', (b / max) * 100 + '%');
        label.textContent = currency + ' ' + a + ' – ' + currency + ' ' + b;
      }

      function onSlide(event) {
        var a = Number(lowSlider.value);
        var b = Number(highSlider.value);
        if (a > b) {
          if (event.target === lowSlider) lowSlider.value = b;
          else highSlider.value = a;
          a = Number(lowSlider.value);
          b = Number(highSlider.value);
        }
        minField.value = a > 0 ? String(a) : '';
        maxField.value = b < max ? String(b) : '';
        paint();
      }

      lowSlider.addEventListener('input', onSlide);
      highSlider.addEventListener('input', onSlide);
      [minField, maxField].forEach(function (field) {
        field.addEventListener('change', function () {
          var a = parsePrice(minField.value);
          var b = parsePrice(maxField.value);
          lowSlider.value = isNaN(a) ? 0 : Math.max(0, Math.min(max, Math.floor(a)));
          highSlider.value = isNaN(b) ? max : Math.max(0, Math.min(max, Math.ceil(b)));
          paint();
        });
      });
      paint();
      range.appendChild(wrap);
    });
  }

  /* ---------- Start ---------- */
  function init() {
    initSearch();
    initSwipeRows();
    initPriceSliders();
    initMegaMenu();
    addCardHearts();
    initViewToggle();
    initNewsletter();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);

  /* Filter laden das Raster neu: Herzen und Ansicht wieder setzen */
  var gridContainer = document.getElementById('ProductGridContainer');
  if (gridContainer) {
    new MutationObserver(function () {
      addCardHearts();
      applyView();
    }).observe(gridContainer, { childList: true, subtree: true });
  }

  /* Filter werden nach dem Filtern neu geladen: Schieberegler wieder einsetzen */
  var filterRoots = document.querySelectorAll('facet-filters-form, menu-drawer.mobile-facets__wrapper, .facets-container');
  if (filterRoots.length) {
    var sliderTimer = null;
    var sliderObserver = new MutationObserver(function () {
      clearTimeout(sliderTimer);
      sliderTimer = setTimeout(initPriceSliders, 60);
    });
    filterRoots.forEach(function (root) {
      sliderObserver.observe(root, { childList: true, subtree: true });
    });
  }
})();